module.exports = __webpack_public_path__ + "img/vegetable-bok-choy-190x100.588ef25b.jpg";